module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("Add Company")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Company",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.company
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.company.name = $$v
      },
      expression: "company.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please select state"
    },
    model: {
      value: (_vm.company.state),
      callback: function($$v) {
        _vm.company.state = $$v
      },
      expression: "company.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "VIC",
      "value": "VIC"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "NSW",
      "value": "NSW"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.city),
      callback: function($$v) {
        _vm.company.city = $$v
      },
      expression: "company.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.address),
      callback: function($$v) {
        _vm.company.address = $$v
      },
      expression: "company.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Post"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.post),
      callback: function($$v) {
        _vm.company.post = $$v
      },
      expression: "company.post"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handelCreateCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handelCreateConfrim
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData3,
      "border": "",
      "fit": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post",
      "label": "Post"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ded8b4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tables/Dynamic.vue
// module id = 769
// module chunks = 2